import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import uiReducer from './uiSlice'
import projectReducer from './projectSlice'
import projectsReducer from './projectsSlice'
import workspaceAssetsReducer from './workspaceAssetsSlice'
import usersReducer from './usersSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    project: projectReducer,
    projects: projectsReducer,
    workspaceAssets: workspaceAssetsReducer,
    users: usersReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
